import * as actions from "./dokumenKerjasama.actions";
import * as types from "./dokumenKerjasama.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { DokumenKerjasamaReducerType } from "./types";

export type DokumenKerjasamaActions = ActionType<typeof actions>;

export const initialState: DokumenKerjasamaReducerType = {
  error: null,
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  selectedFile: null,
  listDokumenKerjasama: [],
  selectedDokumenKerjasama: null,
};

export const DokumenKerjasamaReducer = createReducer<
DokumenKerjasamaReducerType,
  DokumenKerjasamaActions
>(initialState)
  // GET BENTUK KERJASAMA
  .handleAction(actions.getDokumenKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: '',
    errorMessage: '',
  }))
  .handleAction(actions.getDokumenKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    listDokumenKerjasama: action.payload.data.items,
  }))
  .handleAction(actions.getDokumenKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET BENTUK KERJASAMA DETAIL
  .handleAction(actions.getDetailDokumenKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getDetailDokumenKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    selectedDokumenKerjasama: action.payload.data,
  }))
  .handleAction(actions.getDetailDokumenKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE BENTUK KERJASAMA
  .handleAction(actions.updateDokumenKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.updateDokumenKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '/dokumen-kerjasama',
  }))
  .handleAction(actions.updateDokumenKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE BENTUK KERJASAMA
  .handleAction(actions.createDokumenKerjasamaAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.createDokumenKerjasamaAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '/dokumen-kerjasama',
  }))
  .handleAction(actions.createDokumenKerjasamaAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_DOKUMEN_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    selectedDokumenKerjasama: action.payload.dokumenKerjasama
  }))
  
  .handleAction(types.SELECT_DOKUMEN_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedDokumenKerjasama: action.payload.dokumenKerjasama,
  }))

  .handleAction(types.UPDATE_NOMOR_DOKUMEN_PT as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_NOMOR_PT: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_JUDUL_DOKUMEN as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_JUDUL_KERJASAMA: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_NOMOR_DOKUMEN as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_NOMOR: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.DELETE_FILE as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_FILE_NAME: ''
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_ANGGOTA as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          ANGGOTA: action.payload.items
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_JENIS_DOKUMEN as any, (state, action) => ({
    ...state,
    listDokumenKerjasama: (() => {
      if (action.payload.newDetail.DOK_JENIS_PARENT) {
        return state.listDokumenKerjasama;
      } else {
        return [];
      }
    })(),
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_JENIS_ID: action.payload.newId,
          DOK_JENIS_DETAIL: action.payload.newDetail,
          DOK_NOMOR_INDUK: null,
          DOK_DETAIL: null
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_DESKRIPSI as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_DESCR: action.payload.value
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_PIC_UMN as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          EMP_ID: action.payload.newId,
          EMP_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_TANGGAL_MULAI as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          PERIODE_AWAL: action.payload.value
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_TANGGAL_SELESAI as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          PERIODE_AKHIR: action.payload.value
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          STATUS_ID: action.payload.newId,
          STATUS_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_PELAKSANA as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DEPT_ID: action.payload.newIds,
          PELAKSANA_KERJASAMA: action.payload.newDetail
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_PARTNER as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          CO_ID: action.payload.newIds,
          CO_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_BENTUK_KERJASAMA as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          KERMA_ID: action.payload.newIds,
          BENTUK_KERJASAMA: action.payload.newDetail
        };
      } else {
        return null;
      }
    })()
  }))

  .handleAction(types.UPDATE_NOMOR_DOKUMEN_INDUK as any, (state, action) => ({
    ...state,
    selectedDokumenKerjasama: (() => {
      if (state.selectedDokumenKerjasama) {
        return {
          ...state.selectedDokumenKerjasama,
          DOK_NOMOR_INDUK: action.payload.newId,
          DOK_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_FILE as any, (state, action) => ({
    ...state,
    selectedFile: action.payload.file
  }));